<template>
  <a class="document-link" :href=url target="_blank" rel="noopener">
    <img v-if="cover" class="download-cover" :src="cover" alt="">
    <span class="download-message">
      <span class="download-icon" aria-hidden="true"> 
        <arrow-right fillColor="#216C42" :size="24" />
      </span>
      {{ name }}<!--span class="a11y-solo-lectura"> (Link externo).</span-->
    </span>
  </a>
</template>

<script>
import ArrowRight from 'vue-material-design-icons/ArrowRightCircle.vue'

export default {
  name: 'DocumentLik',
  components: {
    ArrowRight
  },
  props: {
    name: String,
    url: String,
    cover: String,
    color: {
      type: String,
      default: "#216C42"
    }
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {},
}
</script>

<style scoped lang="scss">
.document-link {
  display: block;
  .download-cover {
    display: block;
    border-radius: $border-radius;
    border: 1px solid rgba(0,0,0,.1);
    box-shadow: 0 4px 10px rgba(0,0,0,.1);
    overflow: hidden;
    transition: box-shadow .27s ease-in-out;
    width: 378px;
    height: auto;
  }
  .download-message {
    margin: $space * .5 0 0;
    display: flex;
    align-content: center;
    color: $accion;
    transition: color .27s ease-in-out;
  }
  .download-icon {
    .material-design-icon {
      margin-right: $space * .25;
      transition: margin-right .27s ease-in-out, margin-left .27s ease-in-out;
    }
  }
  &:hover, &:focus {
    background: none;
    .download-cover {
      box-shadow: 0 4px 10px rgba(0,0,0,.3);
    }
    .download-message {
      color: $accion;
    }
    .download-icon {
      .material-design-icon {
        margin-right: $space * .15;
        margin-left: $space * .25;
      }
    }
  }
}
</style>
